import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("span", { style: { "text-decoration": "none !important" } }, "←", -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "link-in-text" }, "Zurück", -1);
const _hoisted_3 = [
    _hoisted_1,
    _hoisted_2
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", {
        class: "font7-responsive pointerhover",
        title: "Einen Schritt zurück",
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.stepBackLink && _ctx.stepBackLink(...args)))
    }, _hoisted_3));
}
